module.exports = __webpack_public_path__ + "img/gallery_img_04_s.9ee51ecb.jpg";